const mediaItems = [
  {
    id: 1,
    title: '最新热播剧集精选',
    tag: '电视剧',
    source: '红桃视频',
    views: '128.6万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20drama%20series%20scene%20with%20soft%20golden%20lighting%2C%20elegant%20interior%20with%20warm%20tones%2C%20film%20grain%20texture%2C%20Korean%20drama%20style%20aesthetic%2C%20emotional%20atmosphere&width=640&height=360&seq=media-thumb-1&orientation=landscape',
  },
  {
    id: 2,
    title: '高分动作大片合集',
    tag: '电影',
    source: '樱桃视频',
    views: '96.3万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Action%20movie%20cinematic%20scene%20with%20warm%20dramatic%20lighting%2C%20urban%20night%20setting%20with%20golden%20neon%20glow%2C%20film%20texture%2C%20thriller%20atmosphere%2C%20modern%20cinema%20aesthetic&width=640&height=360&seq=media-thumb-2&orientation=landscape',
  },
  {
    id: 3,
    title: '热门综艺一周速递',
    tag: '综艺',
    source: '茄子视频',
    views: '215.8万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20warm%20vibrant%20lighting%2C%20entertainment%20studio%20set%20with%20colorful%20warm%20decor%2C%20lively%20atmosphere%2C%20modern%20TV%20production%20aesthetic&width=640&height=360&seq=media-thumb-3&orientation=landscape',
  },
  {
    id: 4,
    title: '经典动漫全季回顾',
    tag: '动漫',
    source: '糖心视频',
    views: '87.2万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20colorful%20illustration%20with%20warm%20sunset%20lighting%2C%20vibrant%20characters%20in%20modern%20animation%20style%2C%20soft%20dreamy%20atmosphere%2C%20Japanese%20anime%20aesthetic&width=640&height=360&seq=media-thumb-4&orientation=landscape',
  },
  {
    id: 5,
    title: '纪录片人文探索频道',
    tag: '纪录片',
    source: '红桃视频',
    views: '52.4万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Documentary%20style%20nature%20scene%20with%20warm%20golden%20hour%20lighting%2C%20vast%20landscape%20with%20soft%20atmospheric%20haze%2C%20cinematic%20composition%2C%20natural%20earth%20tones%2C%20exploration%20theme&width=640&height=360&seq=media-thumb-5&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-movie-2-line"></i>
            <span>热门内容</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            精选视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            聚合多个热门站点的精选内容，高清画质流畅播放
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 text-background-50 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-2xl ml-1"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 flex items-center gap-1">
                  <i className="ri-link"></i>
                  来源：{item.source}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {mediaItems.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 text-background-50 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-2xl ml-1"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 flex items-center gap-1">
                  <i className="ri-link"></i>
                  来源：{item.source}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}